import React from "react";
import { Helmet } from "react-helmet";
import dayjs from "dayjs";
import styles from "../publicvehicle.module.css";

/*
 * Page frame for the public vehicle pages: navy header (PropertyDek · property, title, context line),
 * optional step indicator, content, and a property contact footer.
 * steps: [{ label, state: "done" | "active" | "todo" }]
 */
const PublicShell = ({ title, context, propertyName, propertyAddress, propertyPhone, steps, children }) => (<div className={styles.page}>
  <Helmet title={title} />
  <header className={styles.header}>
    <div className={styles.brandRow}>
      <span className={styles.brandMark}>P</span>
      <span className={styles.brandName}>PropertyDek</span>
      {propertyName && <span className={styles.brandProperty}>· {propertyName}</span>}
    </div>
    <h1 className={styles.title}>{title}</h1>
    {context && <p className={styles.context}>{context}</p>}
  </header>

  <main className={styles.body}>
    {steps && steps.length > 0 && (<ol className={styles.steps}>
      {steps.map((step, index) => (<li key={step.label} className={styles["step_" + step.state]}>
        <span className={styles.stepDot}>{step.state === "done" ? "✓" : index + 1}</span>
        <span className={styles.stepLabel}>{step.label}</span>
      </li>))}
    </ol>)}
    {children}
  </main>

  <footer className={styles.footer}>
    {propertyName && <p className={styles.footerName}>{propertyName}</p>}
    {propertyAddress && <p>{propertyAddress}</p>}
    {propertyPhone && <p><a href={"tel:" + propertyPhone}>{propertyPhone}</a></p>}
    <p className={styles.footerCopy}>PropertyDek © {dayjs().format("YYYY")}</p>
  </footer>
</div>);

export default PublicShell;
